import { joinClassNames } from "@/lib/classNames";

interface SectionDividerProps {
  className?: string;
}

export function SectionDivider({ className }: SectionDividerProps) {
  return (
    <div className={joinClassNames("py-2 md:py-4", className)} aria-hidden="true">
      <div className="mx-auto h-px max-w-2xl bg-gradient-to-r from-transparent via-accent/30 to-transparent" />
    </div>
  );
}
